import {
    LAUNCH_INIT,
    SET_CURRENT_APP_ID,
    LOAD_CURRENT_APPLICATION_REQUEST,
    SET_CURRENT_APPLICATION,
    SET_CURRENT_APPLICATION_LOADING,
    CHANGE_WEBHOOK_URL_REQUEST,
    CHANGE_ACCESS_RESTRICTED_REQUEST,
    CHANGE_ALLOW_SECURITY_URL_REQUEST,
    CHANGE_AUTHENTICATION_IN_CHAT_REQUEST,
    CHANGE_NOW_SETTINGS_REQUEST,
    CHANGE_NOW_NOTIFICATION_REQUEST,
} from './constants'

export function launchInit() {
    return {
        type: LAUNCH_INIT
    }
}

export function setCurrentAppId(payload: string) {
    return {
        type: SET_CURRENT_APP_ID,
        payload
    }
}

export function loadCurrentApplicationRequest() {
    return {
        type: LOAD_CURRENT_APPLICATION_REQUEST,
        payload: {}
    }
}

export function setCurrentApplication({ application }) {
    return {
        type: SET_CURRENT_APPLICATION,
        payload: {
            application
        }
    }
}

export function setCurrentApplicationLoading(value = false) {
    return {
        type: SET_CURRENT_APPLICATION_LOADING,
        payload: value
    }
}

export function changeWebhookUrlRequest({ url }) {
    return {
        type: CHANGE_WEBHOOK_URL_REQUEST,
        payload: {
            url
        }
    }
}

export function changeRestrictedAccess(access_token_required = true) {
    return {
        type: CHANGE_ACCESS_RESTRICTED_REQUEST,
        payload: access_token_required
    }
}

export function changeSecurityUrl(allow_security_url = true) {
    return {
        type: CHANGE_ALLOW_SECURITY_URL_REQUEST,
        payload: allow_security_url
    }
}

export function changeAuthenticationInChat(authentication_in_chat) {
    return {
        type: CHANGE_AUTHENTICATION_IN_CHAT_REQUEST,
        payload: {
            authentication_in_chat
        }
    }
}

export function changeNowSettingsRequest(payload) {
    return {
        type: CHANGE_NOW_SETTINGS_REQUEST,
        payload,
    }
}

export function changeNowNotificationRequest(notification) {
    return {
        type: CHANGE_NOW_NOTIFICATION_REQUEST,
        payload: {
            notification
        }
    }

}